module.exports = __webpack_public_path__ + "img/MP-Logo-Colour.f50b4081.svg";